import CoverageView from "@/react/components/entityViews/coverage/CoverageView";

export const CoveragePage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="coverage-page">
      <div className="flex-1 min-h-0">
        <CoverageView />
      </div>
    </div>
  );
};

export default CoveragePage;
